import React from 'react';

import startCase from 'lodash/startCase';

import ManagedFormGroup from 'components/form/managed_input/form_group';
import Options from 'components/form/managed_input/options';

import type { AddContactWorkflow } from './workflow';

interface Props {
  workflow: AddContactWorkflow;
}

export function VisibilityInput({ workflow }: Props) {
  const { visibilityOptions, visibility } = workflow;

  if (!visibilityOptions) {
    return null;
  }

  return (
    <ManagedFormGroup
      label="Contact Visibility"
      required
      type="select"
      value={visibility}
      onValueChange={visibility => workflow.change({ visibility })}
    >
      <Options options={visibilityOptions.map(option => ({ label: startCase(option), value: option }))} />
    </ManagedFormGroup>
  );
}
